import styled, { css } from 'styled-components';
import { Radio } from 'antd';
import { darkTheme, lightTheme } from '@styles/themes';

export const LogoUploadContainer = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-evenly;
`;

export const LogoUploadWrapper = styled.div`
  margin: 16px 24px;
  max-width: 216px;
  width: 100%;
`;

export const LogoColorsWrapper = styled.div<{
  color?: string;
  hasColors: boolean;
}>`
  margin: 16px 24px;
  max-width: 240px;
  width: 100%;

  ${({ hasColors }) =>
    !hasColors &&
    css`
      opacity: 0.2;
    `}

  .radio-group-wrapper {
    display: flex;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 10px;
  }

  .radio-group-colors {
    width: 76px;
  }

  .ant-radio-button-checked {
    border: 2px dashed ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => theme.shapes.borderRadius} !important;
    background: ${({ color }) => color};
  }

  .ant-upload-list {
    display: flex;
    flex-wrap: wrap;
  }

  .ant-upload-list-picture-card-container {
    margin-bottom: 0 !important;
  }
  .ant-upload {
    margin: 0 !important;
  }
`;

export const LogoPreview = styled.div<{
  type: 'light' | 'dark';
}>`
  .logo-preview-content {
    max-width: 240px;
    width: 100%;
    height: 80px;
    display: grid;
    place-items: center;
    background: ${({ type }) =>
      type === 'light'
        ? lightTheme.colors.background
        : darkTheme.colors.background};
    padding: 16px 24px;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    border: 1px dashed ${({ theme }) => theme.colors.border};
    position: relative;

    .ant-image-img {
      max-height: 40px;
      width: 100%;
      object-fit: contain;
    }

    .ant-btn {
      cursor: default;
    }
  }
`;

export const PreviewAlert = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.7rem;
  color: ${({ theme }) => theme.colors.text2};
`;

export const LogoColorPreviewContent = styled.div<{
  type: 'light' | 'dark';
  color?: string;
}>`
  display: flex;
  align-items: center;

  .logo-upload-color-preview {
    padding: 8px 16px;
    font-weight: bold;
    text-align: center;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};

    background: ${({ color }) => color};
    color: ${({ theme }) => theme?.colors?.white};
  }

  .ant-btn {
    margin-left: 8px;
    border-color: ${({ color }) => color};

    svg {
      color: ${({ color }) => color};
    }
  }
`;

export const ChosenColor = styled.div<{
  chosenColor?: string;
}>`
  background: ${({ chosenColor }) => chosenColor ?? 'transparent'};
  display: grid;
  place-items: center;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  margin-right: 4px;

  svg {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
  }
`;

export const RadioButton = styled(Radio.Button)`
  margin: 2px !important;
  border-radius: 8px !important;
  border: 2px solid ${({ theme }) => theme.colors.border} !important;
  width: 20px;

  &::before {
    display: none !important;
  }
`;
